import React, { useEffect, useCallback, useState, forwardRef } from 'react';
import Grid from '@mui/joy/Grid';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Divider from '@mui/material/Divider';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';


//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


import SocialMediaLinks from './SocialMediaLinks';
import { getSettings, updateSettings } from '../../Api/common';


const schema = yup.object({
    email: yup.string().required("هذا الحقل مطلوب"),
})


const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export default function ContactUsComponent() {
    const [loading, setLoading] = useState(false)
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const form = useForm({
        defaultValues: {
            email: "",
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };


    const getAllContent = useCallback(async () => {
        const res = await getSettings()
        if (res) {
            setValue('email', res.email)
        }
    }, []);

    const submitcontent = async (data) => {
        setLoading(true)
        try {
            const res = await updateSettings(data)
            if (res) {
                setOpenAlert(true)
                setMessageAlert("تم تعديل البريد الالكترونى بنجاح")
                setLoading(false)
                getAllContent();
            }
        } catch (error) {
            if (error.response) {
                setLoading(false)
                setOpenAlertError(true)
                setMessageAlertError(error.response.data.message)
            }
        }
    }

    useEffect(() => {
        getAllContent();
    }, [getAllContent])

    return (
        <>

            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>

            <h2>البريد الخاص بالتواصل</h2>
            <Grid
                container
                rowSpacing={3}
                direction="column"
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                sx={{ width: '100%' }}
            >
                <Grid xs={6}>
                    <form onSubmit={handleSubmit(submitcontent)}>
                        <FormControl>
                            <FormLabel>البريد الالكتروني</FormLabel>
                            <Input
                                placeholder="soomha@emailaddress.com"
                                sx={{ borderRadius: '15px', height: '45px' }}
                                {...register('email')}
                            />
                            {errors.email &&
                                <Typography
                                    color="danger"
                                    level="body-xs"
                                    variant="plain"
                                >{errors.email?.message}</Typography>
                            }
                        </FormControl>

                        <Button
                            variant='solid'
                            type='submit'
                            loading={loading}
                            sx={{ marginTop: '30px', backgroundColor: '#3E64F4', color: '#FFF', height: '60px', borderRadius: '30px' }}>
                            تحديث البريد الالكترونى
                        </Button>
                    </form>
                </Grid>
            </Grid>

            <Divider sx={{ margin: '50px 0' }} />

            <h2>تابعنا على</h2>
            <Grid
                container
                rowSpacing={3}
                direction="column"
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                sx={{ width: '100%' }}
            >
                <Grid xs={12}>
                    <SocialMediaLinks />
                </Grid>
            </Grid>

        </>
    )
}